import ViewListaSlownikow from "../../components/views/slowniki/oper/ViewListaSlownikow.jsx";
import ViewListaPozycjiSlownika from "../../components/views/slowniki/oper/ViewListaPozycjiSlownika.jsx";
import ViewEdycjaPozycjiSlownika from "../../components/views/slowniki/oper/ViewEdycjaPozycjiSlownika.jsx";

export const slownikiRoutes = [

    {
        path: '/oper/slowniki/lista',
        exact: true,
        roles: ['slowniki_podglad'],
        forbidden: true,
        view: <ViewListaSlownikow/>,
        mode: 'any'
    },
    {
        path: '/oper/slownik/:id/lista',
        exact: true,
        roles: ['slowniki_podglad'],
        forbidden: true,
        view: <ViewListaPozycjiSlownika/>,
        mode: 'any'
    },
    {
        path: '/oper/slownik/:tryb/:id/:pozycjaId',
        exact: true,
        roles: ['slowniki_modyfikacja'],
        forbidden: true,
        view: <ViewEdycjaPozycjiSlownika/>,
        mode: 'any'
    },
]